import React from 'react';

import {Box, Stack, Skeleton} from 'views/components';

const ReimbursementTileSkeleton = () => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 3,
        bgcolor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      {/* Header: title and amount */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          pt: 3,
          pb: 1,
        }}
      >
        <Skeleton variant="text" width={150} height={32} />
        <Skeleton variant="text" width={100} height={32} />
      </Box>

      {/* Images placeholder */}
      <Box
        sx={{
          px: 4,
          pb: 3,
        }}
      >
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rounded" width={120} height={128} />
        </Stack>
      </Box>
    </Box>
  );
};

export default ReimbursementTileSkeleton;
